import './BalancePanel.scss';
import { memo, type PropsWithChildren, type SyntheticEvent } from 'react';

import { CLICK_IDS } from '@sunflower-games/analytics-events';

import { PlusIcon } from '../BalancePlusIcon/PlusIcon';

export const BalancePanel = memo(function BalancePanel(
  props: PropsWithChildren & {
    handleClick: (clickId: string) => void;
  },
) {
  const onPress = (clickId: string) => {
    return (ev: SyntheticEvent<HTMLElement>) => {
      ev.stopPropagation();
      props.handleClick(clickId);
    };
  };

  return (
    <div className="balance-panel" id="gc_balance" onClick={onPress(CLICK_IDS.PURCHASE.HEADER_BALANCE_WRAPPER)}>
      {props.children}
      <div className="balance-panel-right">
        <PlusIcon onPress={onPress} />
      </div>
    </div>
  );
});
